import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase/Firebase";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import "./css/styles.css";  
import { useNavigate } from "react-router-dom";

function Login(props) {



  const [email, setEmail] = useState();
  const [pass, setPass] = useState();
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);

  const navigate = useNavigate();
 
 

  const login = (e) => {
    e.preventDefault();
    setLoading(true);

    if (!email || !pass || !email.trim() || !pass.trim()) {
        setLoading(false); 
        return; // Exit the function or component
      }
    signInWithEmailAndPassword(auth, email, pass)
      .then((userCredential) => {
        const user = userCredential.user;
        // console.log(user);
        setLoading(false);
        toast.current.show({
          severity: "success",
          summary: "success",
          detail: "logged in successfully",
        });
        sessionStorage.setItem('user-data',JSON.stringify(user)) 
        navigate("/main")
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
        setLoading(false);
        toast.current.show({
          severity: "error",
          summary: "error",
          detail: "Check Email or Password",
        });
      });
  };

  return (
    <div className="container">
      <Toast ref={toast} />
      <div className="wrapper">
        <div className="title">
          <span>Login Form</span>
        </div>
        <form action="#">
          <div className="row">
            <i className="fas fa-user">👤</i>
            <input
              type="text"
              placeholder="Email or Phone"
              required
              onChange={(e) => setEmail(e.target.value)} 
            />
          </div>
          <div className="row">
            <i className="fas fa-lock">🗝️</i>
            <input
              type="password"
              placeholder="Password"
              required
              onChange={(e) => setPass(e.target.value)}
            />
          </div>
          <div className="pass">
            <a href="#">Forgot password?</a>
          </div>
          {!loading && (
            <div className="row button">
              <input type="button" value="Sign in :)" onClick={login} />
            </div>
          )}
          {loading && (
            <div className="row button">
              <input
                type="button"
                value="Signing in..."
                disabled="disabled"
                style={{ backgroundColor: "grey" }}
              />
            </div>
          )}
          <div className="signup-link">
            Not a member? <a href="#">Signup now</a>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
